import { createSelector } from '@reduxjs/toolkit';

const getState = (state) => state.vision;

export const getVisionPlansSelector = createSelector(getState, (state) => state.visionPlans);
